import { render, staticRenderFns } from "./myHospitalCard.vue?vue&type=template&id=9ecd0a64&scoped=true"
import script from "./myHospitalCard.vue?vue&type=script&lang=js"
export * from "./myHospitalCard.vue?vue&type=script&lang=js"
import style0 from "./myHospitalCard.vue?vue&type=style&index=0&id=9ecd0a64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecd0a64",
  null
  
)

export default component.exports